import { ModulePackFE_NavigationInfo } from '../../_entity/runtime/runtime-navigation-info/index.js';
import { ModulePackFE_RuntimeSmartNoteDB } from '../../_entity/runtime/smart-note/index.js';
import { ModulePackFE_RuntimeFindingDB } from '../../_entity/runtime/runtime-finding/index.js';
import { ModulePackFE_RuntimeSmartDocDB } from '../../_entity/runtime/runtime-smartDoc/index.js';
import { ModulePackFE_RuntimeProtocolDB } from '../../_entity/runtime/runtime-protocol/index.js';
import { ModulePackFE_RuntimeOrderDB } from '../../_entity/runtime/runtime-order/index.js';
import { ModuleFE_SuggestedFinding } from '../ModuleFE_SuggestedFinding.js';
import { ModulePack_ProviderChatDB } from '../../_entity/runtime/provider-chat/index.js';
import { ModulePack_ProviderChatInteractionDB } from '../../_entity/runtime/provider-chat-interaction/index.js';
export const ModulePackFE_Advisor_Runtime = [
    ...ModulePackFE_RuntimeFindingDB,
    ...ModulePackFE_RuntimeProtocolDB,
    ...ModulePackFE_RuntimeSmartDocDB,
    ...ModulePackFE_RuntimeOrderDB,
    ...ModulePackFE_NavigationInfo,
    ...ModulePackFE_RuntimeSmartNoteDB,
    ...ModulePack_ProviderChatDB,
    ...ModulePack_ProviderChatInteractionDB,
    ModuleFE_SuggestedFinding,
];
//# sourceMappingURL=index.js.map